// extracted by mini-css-extract-plugin
module.exports = {"select_phone_code":"InputPhone_select_phone_code__9nKPn","group_phone":"InputPhone_group_phone__2ZzUb"};